const parseJsonResponse = async (response) => {
  const text = await response.text();

  if (!text) {
    return {};
  }

  try {
    return JSON.parse(text);
  } catch {
    return {};
  }
};

const postWithPin = async (url, payload, fallbackMessage) => {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (response.status === 401) {
    throw new Error("De pincode klopt niet.");
  }

  if (!response.ok) {
    const parsed = await parseJsonResponse(response);
    throw new Error(parsed.error || fallbackMessage);
  }

  return parseJsonResponse(response);
};

const postForBlob = async (url, payload, fallbackMessage) => {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (response.status === 401) {
    throw new Error("De pincode klopt niet.");
  }

  if (!response.ok) {
    const parsed = await parseJsonResponse(response);
    throw new Error(parsed.error || fallbackMessage);
  }

  return response.blob();
};

export const loadInvoiceBootstrap = async (pin) =>
  postWithPin("/api/invoice-bootstrap", { pin }, "Factuurgegevens laden is niet gelukt.");

export const createInvoiceCustomer = async ({
  pin,
  customerType,
  name,
  email,
  phone,
  streetAndNumber,
  postalCode,
  city,
  chamberOfCommerce,
  vatNumber,
}) =>
  postWithPin(
    "/api/invoice-create-customer",
    {
      pin,
      customerType,
      name,
      email,
      phone,
      streetAndNumber,
      postalCode,
      city,
      chamberOfCommerce,
      vatNumber,
    },
    "Klant aanmaken is niet gelukt."
  );

export const createInvoicePreview = async ({
  pin,
  contactId,
  description,
  price,
  quantity,
  taxRateId,
  pricesAreInclTax,
  replaceInvoiceId,
}) =>
  postWithPin(
    "/api/invoice-preview",
    { pin, contactId, description, price, quantity, taxRateId, pricesAreInclTax, replaceInvoiceId },
    "Factuurvoorbeeld maken is niet gelukt."
  );

export const sendInvoiceToCustomer = async ({ pin, invoiceId }) =>
  postWithPin("/api/invoice-send", { pin, invoiceId }, "Factuur versturen is niet gelukt.");

export const loadInvoiceList = async ({ pin, state = "all", period = "this_year" }) =>
  postWithPin("/api/invoice-list", { pin, state, period }, "Facturen laden is niet gelukt.");

export const loadInvoicePdf = async ({ pin, invoiceId }) =>
  postForBlob("/api/invoice-pdf", { pin, invoiceId }, "Factuur ophalen is niet gelukt.");

export const sendInvoiceReminderToCustomer = async ({
  pin,
  invoiceId,
  contactId,
  workflowId,
  documentStyleId,
  identityId,
  email,
}) =>
  postWithPin(
    "/api/invoice-reminder",
    { pin, invoiceId, contactId, workflowId, documentStyleId, identityId, email },
    "Herinnering sturen is niet gelukt."
  );
